module.exports = __webpack_public_path__ + "img/direct-download.5ca5cb6e.svg";